import React, { useState } from "react";

// Lib
import { sanitize } from "dompurify";
import { useWindowSize } from 'lib/hooks';
import { shallowEqual } from "react-redux";
import { decodeHtmlEntity } from "lib/helpers";
import { useAppSelector } from "lib/hooks/useDispatch";

// Classnames
import clsx from "clsx";

// UrlParam
import { useNavigate } from "react-router-dom";

// Type
import { ReactSelectTypeValue } from "../type";

// components
import Button from "components/UiKit/Button";
import FieldSelect from "components/UiKit/FieldSelect";

// Constants
import { initialState, optionsFormat, optionsSize } from "constans/libraries-product";

// Styles
import { selectStyle } from "constans/react-select-style";

// Type
type TypeUseStateOptions = {
  id?: string | null | undefined,
  label?: string | null | undefined,
  value?: string | null | undefined,
}
type TypeOptionsFormat = {
  id?: string,
  label?: string,
  value?: string,
}

export const Offer: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop: boolean = useWindowSize().width <= 1024;

  const {
    lib,
    libTargets,
    compoundsCount
  } = useAppSelector(
    (store) => {
      return {
        lib: store.librariesProduct?.libDetailsData?.lib || {},
        libTargets: store.librariesProduct?.libDetailsData?.libTargets,
        compoundsCount: store.librariesProduct?.libDetailsData?.lib?.compoundsCount || "",
      };
    },
    shallowEqual
  );

  const [valueSize, setValueSize] = useState<TypeUseStateOptions>(initialState);
  const [valueFormat, setValueFormat] = useState<TypeUseStateOptions>(initialState);
  const [optionsValueFormat, setOptionsValueFormat] = useState<TypeUseStateOptions[]>(optionsFormat);

  const handlerChangeSelectSize = (e: ReactSelectTypeValue) => {
    setValueSize(e);
    const result = optionsFormat.length ? optionsFormat?.filter(
      (x: TypeOptionsFormat) => x?.id?.includes(e?.id || "")
    ) : [];
    setOptionsValueFormat(result);
  };

  const handlerChangeSelectFormat = (e: ReactSelectTypeValue) => {
    setValueFormat(e);
  };

  const handlerClick = (e: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    const result = {
      param: valueSize?.value || "",
      name: lib?.name ? lib?.name : "",
      format: valueFormat?.value || "",
      compoundsCount: compoundsCount || "",
      catNumber: lib?.catNumber ? lib?.catNumber : ""
    };

    localStorage.setItem("format", JSON.stringify(result));

    navigate("/request-form");
  };

  const cn = clsx(
    "individual-offer",
    !libTargets?.length ? "individual-offer--active" : ""
  );

  return (
    <div className={cn}>
      <div className="wrapper">
        <h4 className="individual-offer__title">Get an individual offer</h4>
        <p className="individual-offer__sub-title">We propose the complete list of Services powered by Enamine</p>

        <form
          onSubmit={handlerClick}
          className="flex flex-ai-start flex-jc-between individual-offer__form flex-direction-column-mobile"
        >
          <FieldSelect
            name="size"
            label="Select size"
            styles={selectStyle}
            options={optionsSize}
            placeholder="Select value"
            onChange={handlerChangeSelectSize}
            className="individual-offer__field-select"
            value={!Object.values(valueSize)?.filter(Boolean)?.length ? [] : valueSize}
          />

          <FieldSelect
            name="format"
            styles={selectStyle}
            label="Select format"
            placeholder="Select value"
            options={optionsValueFormat}
            onChange={handlerChangeSelectFormat}
            className="individual-offer__field-select"
            value={!Object.values(valueFormat)?.filter(Boolean)?.length ? [] : valueFormat}
          />

          {!isDesktop && <Button
            type="submit"
            variable="primary"
            label="Send a request"
            id="bioactive-libraries-btn-offer"
            className="individual-offer__wrapper-form-btn"
          />}
        </form>

        <div className="individual-offer__block-info">
          <span>
            Disclaimer
          </span>
          <p>All our products are for research purpose only. Any personal or non-scientific use is strictly
            prohibited.</p>
          <span>
            Note
          </span>
          <p>All the compounds with solubility below 10 mM are shipped as 2 mM solutions.</p>
        </div>

        {isDesktop && <div className="individual-offer__wrapper-form-btn flex-jc-center">
          <Button
            variable="primary"
            label="Send a request"
            onPress={handlerClick}
            id="bioactive-libraries-btn-offer"
          />
        </div>}

        <div className="individual-offer__content flex flex-ai-start flex-direction-column-desktop">
          <div className="individual-offer__wrapper-ul individual-offer__col1">
            <h4>Product Features</h4>
            <div
              className="individual-offer__ul ql-editor"
              dangerouslySetInnerHTML={{
                __html:
                  sanitize(decodeHtmlEntity(lib?.features?.replaceAll("#cmpCount#", `${compoundsCount}`) || "-") || "-")
              }}
            />
          </div>

          <div className="flex flex-ai-start flex-direction-column individual-offer__col2">
            <div className="individual-offer__wrapper-ul">
              <h4>Product Details</h4>
              <ul>
                <li>Format: 10 - 100 µL of 10 mM DMSO stock solutions; dry powders (1 mg);</li>
                <li>Container: 384-well microplates;</li>
                <li>Storage: - 18 °C;</li>
                <li>Shipping: Dry ice.</li>
              </ul>
            </div>

            <div className="individual-offer__wrapper-ul">
              <h4>Utility</h4>
              <ul className="individual-offer__utility">
                <li>High throughput screening (HTS);</li>
                <li>High content screening (HCS);</li>
                <li>Cherry picking.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
